var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewAnalysis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 10C1.25 5.7125 5.3275 2.5 10 2.5C14.6725 2.5 18.75 5.7125 18.75 10C18.75 14.2875 14.6725 17.5 10 17.5C9.47083 17.5 8.95375 17.4608 8.44875 17.3825C7.32375 18.1 6.0225 18.5675 4.62375 18.7075C4.44981 18.7249 4.27446 18.6933 4.11752 18.6163C3.96057 18.5393 3.82828 18.42 3.73559 18.2718C3.64289 18.1236 3.59348 17.9524 3.59293 17.7776C3.59239 17.6028 3.64073 17.4313 3.7325 17.2825C4.02786 16.8003 4.22695 16.2655 4.31875 15.7075C2.47375 14.3575 1.25 12.325 1.25 10Z",
    fill: "#8080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewAnalysis);
export default __webpack_public_path__ + "static/media/review-analysis.4a4f5069856ccf83020418fb30d1d7e1.svg";
export { ForwardRef as ReactComponent };